import {
  ADDPASSWORD,
  ADDPASSWORDLN,
  ALTA,
  ALTAEMPRESA,
  ALTAPARTICULAR,
  APPLICANT_PROFILE,
  AUSENTISMO,
  CONFIGURACION,
  CONTACTOS,
  CUENTA,
  DATOSEMPRESA,
  DECJURADA,
  EMPLOYEES,
  EMPLOYEE_PROFILE,
  ERROR,
  FACTURACION,
  FINALMESSAGE,
  INDEX,
  LOGIN,
  RESTORE,
  POSTULANTES,
  REMOTELINKCONFIRMARTION,
  RESULTADOS,
  SEGURIDAD,
  SUCURSALES,
  TURNCONFIRMATION,
  TURNCANCELLATION,
  TURNOS,
  VALIDATEACCOUNT,
  WITHOUTPROTECTED,
  CLOSE,
  ROLESUSUARIOS,
  EDITDECJURADA,
  TWOFALOGIN,
  REPORTES,
  ASESOR_RESULTADOS,
  GESTIONES_COMERCIALES,
} from "../constants/routes";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Absences from "../pages/Absences";
import Add from "../pages/others/addUsers/Add";
import AddCompany from "../pages/others/addCompany/AddCompany";
import AddFinalMessage from "../pages/others/addFinalMessage/AddFinalMessage";
import AddParticularPatient from "../pages/others/addParticularPatient/AddParticularPatient";
import AddTypes from "../pages/others/addTypes/AddTypes";
import App from "../app/App";
import ApplicantProfile from "../pages/Applicants/Profile";
import Applicants from "../pages/Applicants/index";
import Cuenta from "../pages/Profile/index";
import Dashboard from "../pages/dashboard/Dashboard";
import Declaration from "../pages/declaration/Declaration";
import UpdateDeclaration from "../pages/declaration/updateDeclaration";
import EmployeeProfile from "../pages/Employees/Profile";
import Employees from "../pages/Employees/index";
import Error404 from "../pages/others/Error404";
import FormsDemo from "../pages/others/FormsDemo";
import Login from "../pages/login";
import Restore from "../pages/others/resetPassword";
import ProtectedRoute from "./protectedRoute";
import TurnConfirmation from "../pages/others/turnConfirmation/TurnConfirmation";
import TurnCancellation from "../pages/others/turnCancellation/TurnCancellation";
import Turnos from "../pages/Turnos/index";
import ResultsPage from "../pages/Results";
import { AddPassword } from "../pages/others/addPassword";
import { ValidateEmail } from "../pages/others/ValidateEmail";
import UsersRols from "../pages/UsersRoles/usersRolsIndex";
import RemoteLinkConfirmation from "../pages/others/remoteLinkConfirmation/RemoteLinkConfirmation";
import Close from "../pages/others/Close";
import TwoFAPage from "../pages/2FA";
import Security from "../pages/Security";
import Reports from "../pages/Reports/Reports";
import AsesorResultsPage from "../pages/AsesorResults";
import GestionesComercialesPage from "../pages/GestionesComerciales";

export default function RouterApp() {
  return (
    <BrowserRouter>
      <Routes>
        {/* PAGES ROUTES WITHOUT LAYOUT */}
        <Route path={LOGIN} element={<Login />} />
        <Route path={RESTORE} element={<Restore />} />
        <Route path={TWOFALOGIN} element={<TwoFAPage />} />
        <Route
          path={WITHOUTPROTECTED}
          element={<div>RUTA SIN PROTECCION</div>}
        />
        <Route path={ERROR} element={<Error404 />} />
        <Route path={DECJURADA} element={<Declaration />} />
        <Route path={EDITDECJURADA} element={<UpdateDeclaration />} />
        <Route path={TURNCONFIRMATION} element={<TurnConfirmation />} />
        <Route path={TURNCANCELLATION} element={<TurnCancellation />} />
        <Route
          path={REMOTELINKCONFIRMARTION}
          element={<RemoteLinkConfirmation />}
        />

        <Route path={"/formulario/:steps"} element={<FormsDemo />} />
        <Route path={CLOSE} element={<Close />} />

        <Route path={ALTA} element={<Add />}>
          <Route index element={<AddTypes />} />
          <Route path={ALTAEMPRESA} element={<AddCompany />} />
          <Route path={ALTAPARTICULAR} element={<AddParticularPatient />} />
          <Route path={FINALMESSAGE} element={<AddFinalMessage />} />
          <Route path={VALIDATEACCOUNT} element={<ValidateEmail />} />
          <Route path={ADDPASSWORD} element={<AddPassword />} />
          <Route path={ADDPASSWORDLN} element={<AddPassword />} />
        </Route>
        {/* PAGES ROUTES WITHOUT LAYOUT */}

        {/* PAGES ROUTES WITH LAYOUT and AUTH REQUIRED PROTECTION */}
        <Route path={INDEX} element={<App />}>
          <Route
            index
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path={EMPLOYEES}
            element={
              <ProtectedRoute>
                <Employees />
              </ProtectedRoute>
            }
          />
          <Route
            path={EMPLOYEE_PROFILE}
            element={
              <ProtectedRoute>
                <EmployeeProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path={POSTULANTES}
            element={
              <ProtectedRoute>
                <Applicants />
              </ProtectedRoute>
            }
          />
          <Route
            path={APPLICANT_PROFILE}
            element={
              <ProtectedRoute>
                <ApplicantProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path={TURNOS}
            element={
              <ProtectedRoute>
                <Turnos />
              </ProtectedRoute>
            }
          />
          <Route
            path={ROLESUSUARIOS}
            element={
              <ProtectedRoute>
                <UsersRols />
              </ProtectedRoute>
            }
          />
          <Route
            path={RESULTADOS}
            element={
              <ProtectedRoute>
                <ResultsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={AUSENTISMO}
            element={
              <ProtectedRoute>
                <Absences />
              </ProtectedRoute>
            }
          />
          <Route
            path={FACTURACION}
            element={
              <ProtectedRoute>
                <div>FACTURACION</div>
              </ProtectedRoute>
            }
          />
          <Route
            path={CONFIGURACION}
            element={
              <ProtectedRoute>
                <div>CONFIGURACION</div>
              </ProtectedRoute>
            }
          />
          <Route
            path={REPORTES}
            element={
              <ProtectedRoute>
                <Reports />
              </ProtectedRoute>
            }
          />
          <Route
            path={ASESOR_RESULTADOS}
            element={
              <ProtectedRoute>
                <AsesorResultsPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={SEGURIDAD}
            element={
              <ProtectedRoute>
                <Security />
              </ProtectedRoute>
            }
          />
          <Route
            path={GESTIONES_COMERCIALES}
            element={
              <ProtectedRoute>
                <GestionesComercialesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={CUENTA}
            element={
              <ProtectedRoute>
                <Cuenta />
              </ProtectedRoute>
            }
          >
            <Route
              path={DATOSEMPRESA}
              element={
                <ProtectedRoute>
                  <Cuenta />
                </ProtectedRoute>
              }
            />
            <Route
              path={CONTACTOS}
              element={
                <ProtectedRoute>
                  <Cuenta />
                </ProtectedRoute>
              }
            />
            <Route
              path={SUCURSALES}
              element={
                <ProtectedRoute>
                  <Cuenta />
                </ProtectedRoute>
              }
            />
          </Route>
        </Route>
        {/* PAGES ROUTES WITH LAYOUT and AUTH REQUIRED PROTECTION */}
      </Routes>
    </BrowserRouter>
  );
}
